module.exports = "#second-div-filter{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\np-selectButton{\n    margin-right: 10px;\n}\n#deo_spin_loading{\n    margin: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/discards/discards-filter/discards-filter.component.css
// module id = ./src/app/discards/discards-filter/discards-filter.component.css
// module chunks = main